import script from "./PortfolioJustified.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioJustified.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioJustified.vue?vue&type=style&index=0&id=85777d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85777d32"]])

export default __exports__